import gridClientBase from "../../../components/gridClientComponentBase";
import { bus } from "../../../main";

export default {
	extends: gridClientBase,
	props: {
		data: Array,
		gridClass: String,
		vehicleItemsFilter: Array,
		vehicleSelectedFilter: Array,
		driverItemsFilter: Array,
		driversSelectedFilter: Array,
		statusFilter: Array
	},
	data: function() {
		return {
			statusSelectedFilter: [],
			groupsSelectedFilter: [],

			categoryFilters: [],
			categoryFilterSelected: []
		};
	},

	created() {
		var self = this;

		this.hasSelectedMode = true;
		this.items = this.data;

		//Inizialize Filters if already presents
		this.inizializeFilters();

		//bus.$on("marker-click", self.markerClickHandler.bind(self));
		bus.$on("filter-head-change", self.onFilterHeadChange.bind(self));
		bus.$on("category-selected-changed", self.onCategorySelectedChanged.bind(self));
	},
	watch: {
		data: {
			handler() {
				this.items = this.data;

				for (var i = 0; i < this.items.length; i++) {
					var diagnosticItem = this.items[i];
					if (diagnosticItem.category) {
						var alreadyExist =
							this.categoryFilters.findIndex(item => {
								return item.id == diagnosticItem.category;
							}) >= 0;
						if (!alreadyExist) {
							this.categoryFilters.push({
								id: diagnosticItem.category,
								value: diagnosticItem.display_category
							});
						}
					}
				}
			},
			deep: true
		}
	},
	beforeDestroy() {
		var self = this;
		//bus.$off("marker-click", self.markerClickHandler.bind(self));
		bus.$off("filter-head-change");
		bus.$off("category-selected-changed");
	},
	/* metodi */
	methods: {
		onCategorySelectedChanged(category) {
			var itemToSelect = this._.find(this.items, function(x) {
				return x.category === category;
			});

			if (itemToSelect) {
				this.selectRow(itemToSelect);
			}
			else {
				this.deSelectAllRow();
			}
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},
		inizializeFilters() {
			// if (this.vehicleSelectedFilter.length > 0) {
			// 	var filtersToAdd = {
			// 		field: "number_plate",
			// 		type: "multiselect",
			// 		filter: {
			// 			logic: "or",
			// 			filters: []
			// 		}
			// 	};

			// 	for (var i = 0; i < this.vehicleSelectedFilter.length; i++) {
			// 		var f = this.vehicleSelectedFilter[i];
			// 		filtersToAdd.filter.filters.push({
			// 			field: "number_plate",
			// 			operator: "contains",
			// 			value: f
			// 		});
			// 	}

			// 	this.columnFilters.push(filtersToAdd);
			// }
			// if (this.driversSelectedFilter.length > 0) {
			// 	var filtersToAdd = {
			// 		field: "driver_name",
			// 		type: "multiselect",
			// 		filter: {
			// 			logic: "or",
			// 			filters: []
			// 		}
			// 	};

			// 	for (var i = 0; i < this.driversSelectedFilter.length; i++) {
			// 		var f = this.driversSelectedFilter[i];
			// 		filtersToAdd.filter.filters.push({
			// 			field: "driver_name",
			// 			operator: "contains",
			// 			value: f
			// 		});
			// 	}

			// 	this.columnFilters.push(filtersToAdd);
			// }
		},
		internalFiltersToUpdate(e) {
			if (e.field == "display_category")
			{
				this.categoryFilterSelected = [];
			}
		},
		onFilterHeadChange(e) {
			if (e.filterItemsSelected.length > 0) {
				var filterToApply = {
					field: e.field,
					filterType: e.filterType,
					filterItemsSelected: e.filterItemsSelected
				};

				this.filterHandler(filterToApply);
			} else {
				this.removeFilter({
					field: e.field
				});
			}
		},
		markerClickHandler(e) {
			if (e && e.marker) {
				var itemToSelect = this._.find(this.items, function(x) {
					return x.id === e.marker.id;
				});

				var showItemIndex = this.itemToReturnIfIsInEditMode.findIndex(function(x) {
					return x.id == itemToSelect.id;
				});

				var pageSize = this.take;
				var page = parseInt(showItemIndex / pageSize);

				this.skip = this.take * page;

				if (itemToSelect) {
					this.selectRow(itemToSelect);
				}
			}
		}
	},
	computed: {
		columns: function() {
			return [
				{
					field: "display_category",
					title: "Categoria",
					className: "",
					headerCell: "myCategoryHeaderTemplate",
					cell: "myCellTemplate",
					filterable: false
				},
				{
					field: "count",
					title: "Eventi",
					width: "90",
					className: "",
					headerCell: "myHeaderTemplate",
					filterable: false,
					cell: "myCellTemplate"
				},				
				// {
				// 	field: "",
				// 	title: "",
				// 	width: "",
				// 	className: "",
				// 	headerCell: "",
				// 	filterable: false,
				// 	cell: ""
				// },
				// {
				// 	field: "last_event_date",
				// 	title: "Data ultimo evento",
				// 	className: "",
				// 	format: "datetime",
				// 	width: "210",
				// 	headerCell: "myHeaderTemplate",
				// 	filterable: false,
				// 	cell: "myCellTemplate"
				// }
			];
		}
	}
};
